import { lang } from '@ott/l10n';

import { AchievementType } from 'src/types';

import { S3_MP4_URL } from '../../../constants';

export const ACHIEVEMENTS: AchievementType[] = [
  {
    id: 1,
    title: 'Join app',
    description: 'Create your account',
    buttonCaption: 'Sign up',
    buttonAction: `https://www.solartrip.com/${lang}/profile/achievements`,
    cardBg: `${S3_MP4_URL}planet_bg_10.mp4`,
    CTAButtonMobileLink: 'solartrip://solartrip.com/achievements',
  },
  {
    id: 2,
    title: 'First stay',
    description: 'Book and complete your stay',
    buttonCaption: 'Find stays',
    buttonAction: `https://www.solartrip.com/${lang}/hotels`,
    cardBg: `${S3_MP4_URL}planet_bg_1.mp4`,
    CTAButtonMobileLink: 'solartrip://solartrip.com/hotels',
  },
  {
    id: 3,
    title: 'First flight',
    description: 'Book your ticket and take a flight',
    buttonCaption: 'Find flights',
    buttonAction: `https://www.solartrip.com/${lang}/avia`,
    cardBg: `${S3_MP4_URL}planet_bg_2.mp4`,
    CTAButtonMobileLink: 'solartrip://solartrip.com/avia',
  },
  {
    id: 4,
    title: 'Visit five different countries',
    description: 'Fly to or stay in five different countries',
    buttonCaption: 'Find flights',
    buttonAction: `https://www.solartrip.com/${lang}/avia`,
    cardBg: `${S3_MP4_URL}planet_bg_3.mp4`,
    CTAButtonMobileLink: 'solartrip://solartrip.com/avia',
  },
  {
    id: 5,
    title: 'Tenth app booking',
    description: 'Complete your tenth app order',
    buttonCaption: 'Install app',
    buttonAction: 'https://slr.onelink.me/gEAA/e41twegr',
    cardBg: `${S3_MP4_URL}planet_bg_4.mp4`,
    CTAButtonMobileLink:
      'solartrip://solartrip.com/webview?link=https%3A%2F%2Fsolartrip.com%2Fen-us%2Floyalty%2Freferral',
    withoutWebView: true,
  },
  {
    id: 6,
    title: 'First crypto order',
    description: 'First order is paid with cryptocurrency',
    buttonCaption: 'Make a booking',
    buttonAction: `https://www.solartrip.com/${lang}/hotels`,
    cardBg: `${S3_MP4_URL}planet_bg_5.mp4`,
    CTAButtonMobileLink: 'solartrip://solartrip.com/hotels',
  },
  {
    id: 7,
    title: 'First five installs with your link',
    description:
      'Invite five friends to complete registrations in the app using your referral link',
    buttonCaption: 'Invite friends',
    buttonAction: `https://www.solartrip.com/${lang}/loyalty/referral`,
    cardBg: `${S3_MP4_URL}planet_bg_6.mp4`,
    CTAButtonMobileLink:
      'solartrip://solartrip.com/webview?link=https%3A%2F%2Fsolartrip.com%2Fen-us%2Floyalty%2Freferral?view=app',
  },
  {
    id: 8,
    title: 'First app booking from your friend',
    description: "Your friend's first booking using the app",
    buttonCaption: 'Invite friends',
    buttonAction: `https://www.solartrip.com/${lang}/loyalty/referral`,
    cardBg: `${S3_MP4_URL}planet_bg_7.mp4`,
    CTAButtonMobileLink:
      'solartrip://solartrip.com/webview?link=https%3A%2F%2Fsolartrip.com%2Fen-us%2Floyalty%2Freferral?view=app',
  },
  {
    id: 9,
    title: 'First crypto payment from your friend ',
    description: `Your friend's first booking with crypto`,
    buttonCaption: 'Invite friends',
    buttonAction: `https://www.solartrip.com/${lang}/loyalty/referral`,
    cardBg: `${S3_MP4_URL}planet_bg_8.mp4`,
    CTAButtonMobileLink:
      'solartrip://solartrip.com/webview?link=https%3A%2F%2Fsolartrip.com%2Fen-us%2Floyalty%2Freferral?view=app',
  },
];
